<template>
  <div class="index-container">
    <div class="form">
      <div class="form-item">
        <div class="label">门店：</div>
        <div class="value">
          <tenantSelector ref="tenantSelector" v-model="filters.tenant" />
        </div>
      </div>
      <div class="form-item">
        <div class="label">时间：</div>
        <div class="value">
          <dateOptionSelector size="small" v-model="filters.dateTime" ref="dateOptionSelector" :options="dateOptions" />
        </div>
      </div>
      <div class="form-item">
        <el-button size="small" type="primary" icon="el-icon-s-data" @click="getData">统计</el-button>
      </div>
    </div>
    <el-card class="box-card" style="height: 100%">
      <div slot="header" class="clearfix">
        <span style="font-size: 24px; font-weight: bold"><i class="iconfont el-icon-s-data" /> 综合统计</span>
      </div>
      <div class="row">
        <div class="item">
          <i class="iconfont icondingdan" style="color: #67c23a; font-size: 25px" />
          <span>接单量：{{ orderCount }}</span>
        </div>
        <div class="item">
          <i class="iconfont iconchuangjian" style="color: #67c23a; font-size: 25px" />
          <span>完成数：{{ updateCount }}</span>
        </div>
        <div class="item">
          <i class="iconfont iconweibiaoti16" style="color: #67c23a; font-size: 25px" />
          <span>派单数：{{ updateRate }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <i class="iconfont iconjine1" style="color: #f4516c; font-size: 25px" />
          <span>营收额：￥{{ totalAmount }}</span>
        </div>
        <div class="item">
          <i class="iconfont iconweiwaidingdanjiageshenpiliucheng" style="color: #f4516c; font-size: 25px" />
          <span>完成额：￥{{ perOrderAmount }}</span>
        </div>
        <div class="item">
          <i class="iconfont iconweiwaidingdanjiageshenpiliucheng" style="color: #f4516c; font-size: 25px" />
          <span>派单额：￥{{ updatePerAmount }}</span>
        </div>
      </div>
      <el-divider></el-divider>
    </el-card>
    <el-row style="height: 500px">
      <el-col :span="12">
        <echart ref="orderChart" chartID="orderChart" chartHeight="400px" />
        <div align="center">进店走势</div>
      </el-col>
      <el-col :span="12">
        <echart ref="amountChart" chartID="amountChart" chartHeight="400px" />
        <div align="center">营业额走势</div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { analysis } from "@/api/analysis.js";
import echart from "@/components/eChart";
import tenantSelector from "@/components/tenantSelector";
import dateOptionSelector from '@/components/dateOptionSelector';
export default {
  components: {
    tenantSelector,
    dateOptionSelector,
    echart,
  },
  data() {
    return {
      dateOptions: [{ value: "create", name: "开单时间" }],
      filters: {
        tenant: "",
        dateTime: {
          dateType: "create",
          date: [],
        }
      },
      loading: false,
      options: [],

      orderCount: 0,
      updateCount: 0,
      updateRate: "",

      totalAmount: 0,
      perOrderAmount: 0,
      updatePerAmount: 0,

      myChart1: "",
      myChart2: "",
    };
  },
  methods: {
    getData() {
      if (!this.filters.dateTime || !this.filters.dateTime.date.length) {
        this.msg.errorMsg("请选择统计时间");
        return;
      }
      let param = {
        tenant: this.filters.tenant.Key,
        beginDate: this.filters.dateTime.date[0],
        endDate: this.filters.dateTime.date[1],
      };
      analysis(param)
        .then((res) => {
          this.orderCount = res.orderCount;
          this.updateCount = res.updateCount;
          this.updateRate = res.updateRate;

          this.totalAmount = res.totalAmount;
          this.perOrderAmount = res.perOrderAmount;
          this.updatePerAmount = res.updatePerAmount;
          debugger;
          let orderChartOptions = this.getChartOptions("订单量","#67c23a",res.xAxis, res.orderLine);
          this.$refs.orderChart.showChart(orderChartOptions);
          let amountChartOptions = this.getChartOptions("销售额","#f4516c", res.xAxis, res.amountLine);
          this.$refs.amountChart.showChart(amountChartOptions);
        })
        .catch((ex) => {
          this.msg.errorMsg(ex);
        });
    },

    getChartOptions(name,color, xAxis, series) {
      let option = {
        color:[color],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [name],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: [{
          name: name,
          data: series,
          type: "line"
        }],
      };
      return option;
    },
  },
  mounted() {
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
    const end = new Date();
    this.filters.dateTime.date = [start, end];
    setTimeout(() => {
      this.getData();
    }, 1000);
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-tabs--border-card>.el-tabs__content {
  padding: 0;
  height: 1px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .item {
    flex: 1;
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    span {
      margin-left: 20px;
      font-size: 20px;
    }
  }
}

.chart {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .item {
    flex: 1;
  }
}

.index-container {
  font-size: 20px;

  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;

    .box {
      margin-top: 20px;
      background: white;
    }

    .panel {
      background: white;
      border-radius: 5px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 40px 60px;
      box-sizing: border-box;

      .iconfont {
        font-size: 80px;
        margin-right: 100px;
      }

      .name {
        margin-bottom: 20px;
        font-size: 25px;
      }

      .count {
        font-size: 40px;
        font-weight: bold;
        text-align: right;
      }
    }
  }
}
</style>